import { render, staticRenderFns } from "./bak.vue?vue&type=template&id=1a3819f0&scoped=true&"
import script from "./bak.vue?vue&type=script&lang=js&"
export * from "./bak.vue?vue&type=script&lang=js&"
import style0 from "./bak.vue?vue&type=style&index=0&id=1a3819f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3819f0",
  null
  
)

export default component.exports